
$(function () {

    $(document).on('postcodeKeyPress', function (e) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $('#find-address').click();
            return false;
        }
    });

    $(document).on('change', '#formChooseProduct [data-val-required], #formChooseProduct [data-val-equalto]', function (e) {
      
        var $form = $('#formChooseProduct');
        var formValid = $form.validate().checkForm();
        if (formValid) {
            $('#btnProceedToPayment').prop('disabled', false);
            $('#btnProceedToPayment').removeClass('disabled');
        } else {
            $('#btnProceedToPayment').prop('disabled', true);
            $('#btnProceedToPayment').addClass('disabled');
        }
    });

    $('#formChooseProduct').on('submit', function (e) {

        const $self = $(this);

        var preventSubmit = false;

        if ($('#proceed-to-payment').hasClass('disabled')) {
            return preventSubmit;
        }

        if ($self.hasClass('byemail')) {
            if (!validateChooseProductSubmitForByEmail($self)) {
                preventSubmit = true;
            }
        }

        if ($self.hasClass('bypost')) {
            if (!validateChooseProductSubmitForByPost($self)) {
                preventSubmit = true;
            }
        }

        if (preventSubmit) {
            e.preventDefault();
        } else {
            $(this).find('[type="submit"]').prop('disabled', true);
        }
    });

    const $valueTextbox = $('#textboxGiftCardPriceX');

    toggleAddAnotherDisplayBasedOnSelectedValue($valueTextbox);

    $valueTextbox.on('change keyup', function () {
        toggleAddAnotherDisplayBasedOnSelectedValue($(this));
    });

    $valueTextbox.rules('add', {
        min: $valueTextbox.data('min-value'),
        max: $valueTextbox.data('max-value'),
        messages: {
            min: $valueTextbox.data('bad-amount-message'),
            max: $valueTextbox.data('bad-amount-message')
        }
    });
});

function validateChooseProductSubmitForByPost($form) {
    EnterAddressManually();
    return $form.valid();
}

function validateChooseProductSubmitForByEmail($form) {

    var isValid = true;

    if (!$form.valid()) {
        isValid = false;
    }

    if (!window.validateDeliveryDateForByEmail()) {
        isValid = false;
    }

    return isValid;
}

function toggleAddAnotherDisplayBasedOnSelectedValue($valueTextbox) {

    const current = parseInt($valueTextbox.val());
    const min = $valueTextbox.data('min-value');
    const max = $valueTextbox.data('max-value');

    if ((current + min) > max || (isNaN(current) && (min + min) > max)) {
        $('#btnProceedToPayment_AddAnother').hide();
    } else {
        $('#btnProceedToPayment_AddAnother').show();
    }
}